export default __webpack_public_path__ + "b71cb7b296348862e85c3779e7f224c2.jpg";